import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import ThemeProvider from 'react-bootstrap/ThemeProvider';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { Spinner, Alert } from 'react-bootstrap';
import './login.css';
import './PasswordOtpForm.css';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from "react-redux";
import { loginPending, loginSuccess, loginFail, logout } from "./loginSlice";
import  { ForgotPassword } from "../login/ForgotPassword";
import UpdatePasswordForm from "./UpdatePasswordForm";


function Copyright(props) {
  return (
    <p className="mt-3 mb-3" variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <a color='inherit' href='#'>
        Royal Arabian Tours
      </a>{' '}
      {new Date().getFullYear()}
      {'.'}
    </p>
  );
}
/* function validateForm() {

  return email.length > 0 && password.length > 0;

} */
//const Login = props => {
const PasswordOtpForm = () => {

  const {showUpdatePassForm} = useSelector(state => state.password);


  return (
    <div className="login-container-fluid">
      <Row>
        <Col xs lg="7" className="forgotpassword-bg"><div></div></Col>
        <Col xs lg="5">

          <div className="forgot-second-col">
            <img
              src='/images/RATourlogo.webp'
              srcSet='/images/RATourlogo.webp'
              alt='Royalarabian Tours'
              loading="lazy"

            />
            <ThemeProvider
              breakpoints={['xxxl', 'xxl', 'xl', 'lg', 'md', 'sm', 'xs', 'xxs']}
              minBreakpoint="xxs"
            >
              {showUpdatePassForm ? <UpdatePasswordForm/> : <ForgotPassword/>}
                 
              <p className="forgot-password text-right">
                  Remember <a href="/">Login Now</a>
                </p>  
             
              <hr />
              <br />
              <Copyright />
            </ThemeProvider>
          </div>
        </Col>
      </Row>

    </div>
  );
}
ForgotPassword.prototype = {
  formSwitcher: PropTypes.func.isRequired,
}
export default ForgotPassword;